import { createContext } from 'react';
import initialMetaState from './initialMetaState';

const MetaContext = createContext(initialMetaState);

export default MetaContext;
